'use client';

import { useProduct } from '@/contexts/ProductContext';
import YotpoStars from '@/components/global/yotpo/YotpoStars';

const ProductMasthead = ({ block }) => {
  const { productData } = useProduct();
  const shopifyProductId = productData?.shopify_product_id;
  const productUrl = productData?.url;

  const { product_title, shipping_message, show_review_stars } = block;

  const shippingText = shipping_message?.[0]?.message;

  const handleReviewsClick = (e) => {
    const target = e.target.closest('a');
    if (!target) return;
    const reviewsSection = document.querySelector('[data-name="product-reviews"]');
    if (!reviewsSection) return;
    e.preventDefault();
    reviewsSection.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      {/* Shipping notice */}
      {shippingText && (
        <p className="flex items-center gap-2 text-sm text-primary mb-1">
          <span className="w-2 h-2 rounded-full bg-sea shrink-0" aria-hidden="true" />
          {shippingText}
        </p>
      )}

      {/* Product title */}
      {product_title && (
        <h1 className="font-cormorant text-primary text-2xl font-semibold capitalize my-1">
          {product_title}
        </h1>
      )}

      {/* Yotpo review stars — click scrolls to reviews section */}
      {show_review_stars && shopifyProductId && (
        <div onClick={handleReviewsClick} className="cursor-pointer">
          <YotpoStars productId={shopifyProductId} url={productUrl} />
        </div>
      )}
    </div>
  );
};

export default ProductMasthead;
